import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { methodCards, serviceGroups } from '../../data/site-content';

@Component({
  selector: 'atr-services',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="page-shell">
      <section class="page-hero compact">
        <p class="section-kicker">Services</p>
        <h1>Interior, exterior, and add-on detailing work.</h1>
        <p>
          Exterior cleanup, interior resets, paint correction, tar removal, and targeted extras with Koch Chemie products and careful hand work.
        </p>
      </section>

      <section class="services section">
        <div class="service-grid">
          @for (group of serviceGroups; track group.number) {
            <article class="service-card" [class.featured]="group.featured">
              <h3>{{ group.title }}</h3>
              <ul>
                @for (item of group.items; track item) {
                  <li>{{ item }}</li>
                }
              </ul>
            </article>
          }
        </div>
      </section>

      <section class="method section" aria-label="Products and process">
        <div class="method-copy">
          <p class="section-kicker">Products and process</p>
          <h2>Professional chemistry. Car-safe pressure. Patient work.</h2>
          <p>
            Koch Chemie products support washes, interior cleaning, surface care, pads, polishes, and finishing. Mobile appointments can be requested when water and electricity are available at the location.
          </p>
        </div>
        <div class="method-grid">
          @for (card of methodCards; track card.number) {
            <article>
              <h3>{{ card.title }}</h3>
              <p>{{ card.copy }}</p>
            </article>
          }
        </div>
      </section>

      <section class="cta-band">
        <h2>Not sure what your vehicle needs?</h2>
            <a class="button primary" routerLink="/book">Request a quote</a>
      </section>
    </main>
  `,
})
export class ServicesComponent {
  protected readonly serviceGroups = serviceGroups;
  protected readonly methodCards = methodCards;
}
